<!-- <p-sidebar [(visible)]="visibleModalEnterIMEI" (onHide)="onHide()" position="bottom" styleClass="h-30rem" transitionOptions="500ms cubic-bezier(0, 0, 0.2, 1)">
  <div class="flex flex-column align-items-center px-5">
    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="flex text-center">
        <h2>Configuración del teléfono</h2>
      </div>
      <div class="flex flex-column justify-content-center align-items-center gap-1">
        <p>Introduce el IMEI del teléfono</p>
        <input pInputText type="text" class="w-full text-xl text-center" formControlName="imei">
        <div *ngIf="submitted && f['imei'].errors" class="invalid-feedback">
          <small class="p-error" *ngIf="f['imei'].errors?.['required']">{{ "IMEI" | required }}</small>
          <small class="p-error" *ngIf="f['imei'].hasError('serverError')">{{ errorMessage }}</small>
        </div>
      </div>
      <div class="flex justify-content-center align-items-center mt-3">
        <p-button type="button" (onClick)="onProgressEnrollment()" [loading]="loading">
          <label class="text-xl font-bold cursor-pointer px-2">Activar</label>
        </p-button>
      </div>
    </form>
  </div>
</p-sidebar> -->

<p-dialog [(visible)]="visibleModalEnterIMEI" (onHide)="onHide()" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <form [formGroup]="form" (ngSubmit)="onProgressEnrollment()">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info">
            <h2>Configuración del teléfono</h2>
            <p>Introduce el IMEI de tu teléfono.</p>
          </div>
          <div class="dialog__form smallPadTop">
            <div class="form__group form__group--codeNumber fWidth nMarginBot" [ngClass]="{'form__error':(submitted || f['imei'].touched || !f['imei'].pristine) && f['imei'].errors}">
              <input pInputText type="text" formControlName="imei">
              <span class="form__msgError" *ngIf="(submitted || f['imei'].touched || !f['imei'].pristine) && f['imei'].errors">
                <small class="p-error" *ngIf="f['imei'].errors?.['required']">{{ "IMEI" | required }}</small>
                <small class="p-error" *ngIf="f['imei'].hasError('serverError')">{{ errorMessage }}</small>
              </span>
            </div>
          </div>
          <div class="dialog__btn">
            <button pButton pRipple type="submit" label="Activar" class="p-button-primary p-button-raised p-button-rounded w-full" [loading]="loading" [disabled]="this.form.invalid"></button>
            <p-button *ngIf="hasEnrollmentError" label="Volver al listado de productos" icon="pi pi-angle-left" iconPos="left" [text]="true" [plain]="true"
                      (click)="onGotoStep(SalesWorkflowSteps['select-product'])"></p-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>
